import type { WeatherSection } from "@weather-deck/shared";
import { el } from "./dom";

export function buildForecastStrip(w: WeatherSection): HTMLElement {
  if (!w?.hourly || w.hourly.length === 0) {
    return el("section", { className: "strip" }, [
      el("h3", { text: "Next 48h" }),
      el("p", { text: "unavailable" })
    ]);
  }

  // hourly now carries a full week for the expandable 7-day cards; this strip
  // is explicitly the next 48 h, so it takes only that many.
  const items = w.hourly.slice(0, 48).map((h) => {
    const item = h as unknown as { temp?: number; temperature?: number; precipProb?: number; precipitationProbability?: number; time: string };
    return {
      time: item.time,
      temp: item.temp ?? item.temperature ?? 0,
      precipProb: item.precipProb ?? item.precipitationProbability ?? 0
    };
  });

  const temps = items.map((h) => h.temp);
  const minT = temps.length > 0 ? Math.min(...temps) : 0;
  const maxT = temps.length > 0 ? Math.max(...temps) : 0;
  const norm = (t: number) => (maxT === minT ? 0.5 : (t - minT) / (maxT - minT));

  const bars = el("div", { className: "bars" });
  for (const h of items) {
    const bar = el("div", { className: "bar", title: `${new Date(h.time).toLocaleString("de-DE", { hour: "2-digit", day: "2-digit" })} · ${h.temp.toFixed(1)}° · ${h.precipProb}%` });
    const temp = el("span", { className: "temp" });
    temp.style.height = `${(norm(h.temp) * 100).toFixed(0)}%`;
    const rain = el("span", { className: "rain" });
    rain.style.opacity = (h.precipProb / 100).toFixed(2);
    bar.append(temp, rain);
    bars.append(bar);
  }

  return el("section", { className: "strip" }, [
    el("h3", { text: `Next 48h · min ${minT.toFixed(0)}° / max ${maxT.toFixed(0)}°` }),
    bars
  ]);
}
